function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u7DDA\\u689D",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#E89A4F",
  cx: 8.5,
  cy: 20.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#E89A4F",
  cx: 20.5,
  cy: 8.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("g", {
  id: "sidebar-\\u7DDA\\u689D"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "basic-/-path-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.03196716,14.5538187 L14.5538187,8.03196716 C14.2019291,7.43645382 14,6.74180841 14,6 C14,3.79086089 15.7908611,2 18,2 C20.2091389,2 22,3.79086089 22,6 C22,8.20913887 20.2091389,10 18,10 C17.2581911,10 16.5635462,9.79807043 15.9680328,9.44618082 L9.44618082,15.9680328 C9.79807043,16.5635462 10,17.2581911 10,18 C10,20.2091389 8.20913887,22 6,22 C3.79086089,22 2,20.2091389 2,18 C2,15.7908611 3.79086089,14 6,14 C6.74180841,14 7.43645382,14.2019291 8.03196716,14.5538187 L8.03196716,14.5538187 Z M6,20 C7.10456944,20 8,19.1045704 8,18 C8,16.8954306 7.10456944,16 6,16 C4.89543056,16 4,16.8954306 4,18 C4,19.1045704 4.89543056,20 6,20 C6.73637962,20 6.73637962,20 6,20 Z M20,6 C20,7.10456944 19.1045704,8 18,8 C16.8954306,8 16,7.10456944 16,6 C16,4.89543056 16.8954306,4 18,4 C19.1045704,4 20,4.89543056 20,6 C20,6.73637962 20,6.73637962 20,6 Z",
  id: "basic-/-path",
  fill: "#282C34",
  mask: "url(#mask-2)"
})));

function SvgSidebarLineB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7DDA\u689D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLineB);
export default __webpack_public_path__ + "static/media/sidebar_line-b.e4188298.svg";
export { ForwardRef as ReactComponent };